var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"times_container top-left w50 right margin margin_r_hf margin_l_c"},[(_vm.mainView === 'time_chart')?_c('times-chart'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }